
export interface IHasCrossPrice {
    getCrossPrice(): number | null
    setCrossPrice(crossPrice: number): void
}

function hasCrossPrice<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasCrossPrice {
        private crossPrice: number | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getCrossPrice(): number | null {
            return this.crossPrice
        }
        public setCrossPrice(crossPrice: number): void {
            this.crossPrice = crossPrice
        }
    };
}

export default hasCrossPrice